export default "/_next/static/f3edbd311fcab4cada688372ba64d14b.png";